import { render, staticRenderFns } from "./input-table.vue?vue&type=template&id=a968903e&scoped=true"
import script from "./input-table.ts?vue&type=script&lang=js&external"
export * from "./input-table.ts?vue&type=script&lang=js&external"
import style0 from "./input-table.vue?vue&type=style&index=0&id=a968903e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a968903e",
  null
  
)

export default component.exports